import EditData from './EditData'

export default [{
  path: '/editData',
  name: 'EditData',
  component: EditData,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Edit Data'}
}
]



// WEBPACK FOOTER //
// ./src/pages/editData/router.js